/**
 * verifies that the given argument is a string and not empty
 *
 * @param argument unknown
 *
 * @returns boolean
 */
function isNonEmptyString(argument?: unknown): argument is string {
    return typeof argument === "string" && argument !== ""
}

function isMalformedString(str: string): boolean {
    for (let i = 0; i < str.length; i++) {
        const char = str[i]
        const code = char.charCodeAt(0)

        // Unicode replacement character (�)
        if (char === "\uFFFD") return true

        // Control characters (except \n, \r, \t)
        if (code < 32 && !["\n", "\r", "\t"].includes(char)) return true

        // Optionally: check for characters not in ASCII printable range
        if (code > 126) return true
    }

    return false
}

/**
 * takes the isNonEmptyString approach and adds an optional regular expression pattern to it
 *
 * @param argument any
 * @param pattern RegExp | string | undefined
 * @returns boolean
 */
function isValidString(argument?: unknown, pattern?: string | RegExp): argument is string {
    if (pattern === undefined) {
        return isNonEmptyString(argument)
    }

    if (typeof argument !== "string") {
        return false
    }

    const regexp = new RegExp(pattern)
    return regexp.test(argument)
}

export { isNonEmptyString, isValidString, isMalformedString }
